import { IWidgetOptionValue } from '../../widgets/Widget';
import type { IMultiSelectWidget } from '../../widgets/repository/inputs/multi-select/IMultiSelectWidget';
import { ISingleSelectWidget } from '../../widgets/repository/inputs/single-select/ISingleSelectWidget';

/**
 * Ottiene le opzioni di un widget di tipo select.
 */
// TODO Ci servirebbe un'interfaccia generica per i widget con opzioni.
export function getWidgetFieldDatatypeOptions(
  widget: IMultiSelectWidget | ISingleSelectWidget,
) {
  return widget.options
    .filter((option): option is IWidgetOptionValue => option.type === 'option')
    .map(option => ({
      value: option.value,
      label: option.value,
    }));
}
